import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface ApplicationEntrypoints {
    web?: string;
    webdav?: string;
    rest?: string;
    documentation?: string;
    download_client?: string;
}

export interface Application {
    key: string;
    is_available: boolean;
    is_licensed: boolean;
    entrypoints: ApplicationEntrypoints;
}

export interface DiscoveryState {
    base_domain: string;
    deployment_id: string;
    environment: string;
    applications: {
        items: Application[];
    };
}

const initialState: DiscoveryState = {
    base_domain: '',
    deployment_id: '',
    environment: '',
    applications: {
        items: [],
    },
};

const discoverySlice = createSlice({
    name: 'discovery',
    initialState,
    reducers: {
        setDiscovery: (_state, action: PayloadAction<DiscoveryState>) => {
            return action.payload;
        },
        setApplications: (state, action: PayloadAction<Application[]>) => {
            state.applications.items = action.payload;
        },
    },
});

export const { setDiscovery, setApplications } = discoverySlice.actions;
export default discoverySlice.reducer;
